module.exports = __webpack_public_path__ + "img/0xdf9f62cba37aaa57bbc955a00ecf6cd22b346e3e.629f6db3.png";